import { toAbsoluteUrl } from '../../utils/toAbsoluteUrl';
import { useEffect, useState } from 'react';
import ContactForm from '../ContactForm/ContactForm';
import copy from './copy';
import ErrorMessage from '../ErrorMessage';
import LineDivider from '../LineDivider';
import Modal from '../Modal/Modal';
import Service from '../../Service';

const defaultAgentHeadshot = '/assets/images/avatar-transparent.png';

function AgentHeader(props) {
	const { address, agent, valuationId } = props;
	const service = new Service();
	const [error, setError] = useState(null);
	const [addContactError, setAddContactError] = useState(null);
	const [showContactModal, setShowContactModal] = useState(false);
	const [showContactModalSuccess, setShowContactModalSuccess] =
		useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	function handleResize() {
		setIsMobile(window.innerWidth < 768);
	}

	async function _handleOnSubmit(values) {
		const groupId = agent?.group?.id ?? null;
		values.address = address;

		try {
			await service.createContact(
				values,
				agent.id,
				valuationId,
				groupId,
				'report'
			);

			setShowContactModal(false);
			setShowContactModalSuccess(true);
		} catch (error) {
			setAddContactError('An unexpected error has occurred.');
		}
	}

	function _handleOnContactClose() {
		setShowContactModal(false);
	}

	function _handleOnContactCloseSuccess() {
		setShowContactModalSuccess(false);
	}

	function renderContactModal() {
		if (showContactModal) {
			return (
				<Modal onClose={_handleOnContactClose}>
					<ContactForm
						addContactError={addContactError}
						buttonText="Get My Dashboard!"
						description="Let us know where to send the login info!"
						heading="We’re Creating Your Account Now!"
						onSubmit={_handleOnSubmit}
					/>
				</Modal>
			);
		}

		return null;
	}

	function renderContactModalSuccess() {
		if (showContactModalSuccess) {
			return (
				<Modal onCloseSuccess={_handleOnContactCloseSuccess}>
					<section>
						<h1 className="header">Your Account is Ready!</h1>
						<p className="my-6">
							Login information is on its way to the inbox of the
							email you provided.
						</p>
						<footer className="footer">
							<button
								className="button w-full my-4 flex justify-center h-ms-2"
								onClick={() => _handleOnContactCloseSuccess()}
								type="button"
							>
								Confirm
							</button>
						</footer>
					</section>
				</Modal>
			);
		}

		return null;
	}

	function renderAgentData() {
		if (!agent) {
			setError('No agent found');
		}

		return (
			<div className="flex justify-between items-center">
				<section>
					<h2 className="h-ms-4 mb-1 text-left">{agent.name}</h2>

					<p className="mb-1 text-left">
						{agent.occupation ?? 'Loan Officer'}
					</p>
					{agent.group ? (
						<p className="font-bold text-left">
							{agent.group.name}
						</p>
					) : null}
				</section>
				<img
					alt={`${agent.name} headshot`}
					className="avatar avatar-xl border-theme-dark"
					src={toAbsoluteUrl(agent.headshot ?? defaultAgentHeadshot)}
				/>
			</div>
		);
	}

	function renderHeaderContent() {
		if (isMobile) {
			return (
				<>
					{renderAgentData()}
					<LineDivider />
					<div>
						<p className="h-ms-2 text-left">
							{copy.headerContent.title}
						</p>
						<p className="text-left my-2">
							{copy.headerContent.description}
						</p>
						<button
							className="button w-full my-3 uppercase"
							onClick={() => setShowContactModal(true)}
						>
							{copy.headerContent.button}
						</button>
					</div>
				</>
			);
		}

		return (
			<>
				<div className="property-detail-item">
					<p className="h-ms-2 text-left">
						{copy.headerContent.title}
					</p>
					<p className="text-left my-2">
						{copy.headerContent.description}
					</p>
					<button
						className="button w-full mt-4 uppercase h-ms-1"
						onClick={() => setShowContactModal(true)}
					>
						{copy.headerContent.button}
					</button>
				</div>
				<LineDivider />
				{renderAgentData()}
			</>
		);
	}

	if (error) {
		return <ErrorMessage heading="Error" message={error} />;
	}

	return (
		<>
			<section className="card card-border-theme property-details p-4">
				<section className="md:flex justify-between items-center">
					{renderHeaderContent()}
				</section>
			</section>
			{renderContactModal()}
			{renderContactModalSuccess()}
		</>
	);
}

export default AgentHeader;
